module.exports = __webpack_public_path__ + "img/CS-Lite-Plus-Profiles.a1398de5.jpg";